import React from 'react'

import {
  HeroBlock,
  JobList,
  Peoples,
  Rest,
  WhyWe,
} from 'src/features/main-page'
import { Meta } from 'src/features/seo'
import { RootLayout } from 'src/layouts'
import { useDimensions } from 'src/ui/dimensions'
import { HBox } from 'src/ui/layout'

import { graphql, useStaticQuery } from 'gatsby'

import { getVacanciesByDepartments } from 'src/shared/selectors'
import { TVideoType } from 'shared/constants'

type Props = {}

const Index: React.FC<Props> = () => {
  const data = useStaticQuery<GatsbyTypes.IndexDataQuery>(graphql`
    query IndexData {
      allFile(filter: { relativePath: { regex: "/index//i" } }) {
        edges {
          node {
            name
            relativePath
            childImageSharp {
              fluid(maxWidth: 1900) {
                srcSet
                base64
                src
                aspectRatio
              }
            }
          }
        }
      }
      strapi {
        vacancies(where: { status: "publish" }) {
          id
          slug
          title
          hot
          order
          levels {
            name
          }
          regions {
            name
            id
          }
          excerpt
          department {
            name
            id
            description
            order
          }
          conditions {
            name
            id
          }
          levels {
            id
            name
          }
        }
      }
    }
  `)

  const images = data.allFile.edges.reduce<TImages>((acc, img) => {
    return {
      ...acc,
      [img.node.name]: img.node.childImageSharp?.fluid as TFluidObject,
    }
  }, {})

  const peoplesData = [
    {
      videoId: '1d228ac8bd8299f2935ba0240fe84a97',
      name: 'Алексей Козак, Николай Николенко',
      type: 'rutube' as TVideoType,
      position: 'CEO, CTO',
      description:
        'Подкаст об основании компании, трудностях и перспективах в отрасли, о нехватке кадров и роли технологий в бизнесе, с акцентом на создание приложений, импортозамещение и использование ИИ.',
    },
  ]

  const { isMobile } = useDimensions()

  const vacanciesByDepartmentsData = getVacanciesByDepartments(data)

  let byDepartmentsList: TVacancyShortList = []

  let hotVacancies: TVacancy[] = []

  if (vacanciesByDepartmentsData) {
    hotVacancies = vacanciesByDepartmentsData.vacanciesByDepartments.reduce<
      TVacancy[]
    >((acc, current) => [...acc, ...current.vacancies.filter((v) => v.hot)], [])

    byDepartmentsList = vacanciesByDepartmentsData.vacanciesByDepartments.reduce<
      TVacancyShortList
    >((acc, cur) => {
      let regions: { [name: string]: number } = {}

      cur.vacancies.forEach((v) => {
        v.regions.forEach((r) => {
          if (regions[r]) {
            regions[r] = regions[r] + 1
          } else {
            regions[r] = 1
          }
        })
      })

      let regionsRes: {
        count: number
        name: string
      }[] = []

      for (const key in regions) {
        if (regions.hasOwnProperty(key)) {
          regionsRes = [...regionsRes, { name: key, count: regions[key] }]
        }
      }

      return [
        ...acc,
        {
          departmentName: cur.departmentName,
          departmentId: cur.id,
          regions: regionsRes,
          description: cur.description,
        },
      ]
    }, [])
  }

  const sliderItems = [
    {
      image: images['rest1'],
    },
    {
      image: images['rest2'],
    },
    {
      image: images['rest3'],
    },
    {
      image: images['rest4'],
    },
    {
      image: images['rest5'],
    },
    {
      image: images['rest6'],
    },
    {
      image: images['rest7'],
    },
    {
      image: images['rest8'],
    },
    {
      image: images['rest9'],
    },
    {
      image: images['rest10'],
    },
    {
      image: images['rest11'],
    },
  ]

  const sliderText = {
    label: 'КАРЬЕРА В KODE',
    title: 'Стань тем,\nкем мечтаешь',
    text:
      'В KODE фокусируются на амбициях и способностях сотрудника. С нами легко строить карьеру мечты и создавать полезные продукты для известных компаний и сотен тысяч пользователей.',
  }

  return (
    <RootLayout withoutNavShadow>
      <Meta
        title="Работа в IT компании мобильной разработки — KODE"
        description="Ищете работу в IT? Компания KODE приглашает тебя стать частью дружной команды ✔ Ищем UX-дизайнеров, аналитиков, QA, разработчиков ✔ Офис в Калининграде"
      />
      {isMobile ? <HBox /> : null}
      <HeroBlock sliderText={sliderText} images={images} />
      {isMobile ? <HBox height={80} /> : <HBox height={112} />}
      <WhyWe images={images} />
      {/* {isMobile ? <HBox height={48} /> : <HBox height={112} />}
      <Peoples data={peoplesData} /> */}
      {isMobile ? <HBox height={72} /> : <HBox height={112} />}
      <Rest images={images} sliderItems={sliderItems} />
      {isMobile ? <HBox height={48} /> : <HBox height={48} />}

      {vacanciesByDepartmentsData &&
      vacanciesByDepartmentsData.vacanciesByDepartments.length > 0 ? (
        <JobList byDepartmentsList={byDepartmentsList} hotList={hotVacancies} />
      ) : null}

      <HBox height={72} />
    </RootLayout>
  )
}

export default Index
